import React, { useEffect, useState } from "react";
import { auth } from "services/firebase";

import Login from "components/Admin/Login";
import List from "components/Admin/List";

export default function AdminPage() {
    const [isLoading, setIsLoading] = useState(true);
    const [isLogged, setIsLogged] = useState(false);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setIsLoading(true);
            if (user) {
                // const uid = user.uid;
                setIsLogged(true);
            } else {
                // User is signed out
                setIsLogged(false);
            }
            setIsLoading(false);
        });
    }, [])

    const renderPage = isLogged ? <List isLogged={isLogged} /> : <Login />

    return (
        <>
            {isLoading ? null : renderPage}
        </>
    )
}
